import axios from "axios";

if (document.querySelector('.n-rates__item')) {
    getSubscribes();
    let month = 'month'

    if (document.querySelector('html').lang === 'ru') {
        month = 'месяц'
    }

    async function getSubscribes() {
        try {
            let response = await axios.get('/subscribe');
            document.querySelectorAll('.n-rates__item-price-value')[0].innerHTML = response.data[0].price + '€/' + month;
            document.querySelectorAll('.n-rates__item-price-value')[1].innerHTML = response.data[1].price + '€/' + month;
        } catch (event) {
            console.dir(event);
        }
    }
}
